import { Suspense, useEffect, useMemo, useState } from "react";
import { useDataFetch } from "../../../../hooks/useDataFetch2";
import { useColumns } from "../utils/columns";
import Breadcrumb from "../../../../components/ui/materialui/breadcrumb";
import { Box, Grid2, Paper } from "@mui/material";
import CustomAccordion from "../../../../components/ui/materialui/customAccordion";
import InputSelect from "../../../../components/inputs/yup/materialui/inputSelect";
import InputFecha from "../../../../components/inputs/yup/materialui/inputFecha";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import TableHeader from "../../../../components/ui/materialui/tableHeader";
import { exportExcel } from "../../../../utils/exportExcel";
import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone';
import { useForm } from "react-hook-form";
import { FilterList } from "@mui/icons-material";
import { selectorTransversal } from "../../../../dtos/selector";
import { AxiosResponse } from "axios";
import { getValoresDominio } from "../../../../services/servicesDominio";
import { Dominios, FiltroMovimientoContable, StatusCode, TipoFuncionalidad } from "../../../../utils/enums";
import { getArchivo } from "../service/service";
import { MovimientoContable, MovimientoContableEmitir } from "../models/consultaMovimientoContable";
import { useMovimientoContable } from "../hooks/useMovimientoContable";
import { get } from "http";
import Tabla from "../../../../components/ui/materialui/tabla";
import { descargarMovimientoContable } from "../../../detalleMutuo/services/servicesReportes";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { format } from "date-fns";
import { ListResponseDto } from "../../../../dtos/ListResponseDto";
import { PermissionGuard } from "../../../../components/auth/ProtectedRoute";



export interface FiltroMovimientosContables {
    fecha: Date;
    codigoAccion: string;
}

const validationSchema = yup.object().shape({
  codigoAccion: yup.string().required("La acción contable es requerida"),
  fecha: yup.date().required("La fecha es requerida"),
});

function ConsultarMovimientosContables() {

    const {
        formState: { errors },
        control,
        handleSubmit,
        setValue,
    } = useForm<FiltroMovimientosContables>({
        mode: 'onBlur',
         resolver: yupResolver(validationSchema),
    })

    const [options, setOptions] = useState<selectorTransversal[]>([]);
    const { dataMovimiento, getMovimientosContables } = useMovimientoContable();

    const tipoAccionContable = async () => {

        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getValoresDominio(Dominios.ACCION_CONTABLE)
        if (resp.status === StatusCode.Ok) {
            const data: selectorTransversal[] = await resp.data.items;
            setOptions(data)
        }
        return;
    }
useEffect(() => {
    const inicializar = async () => {
        await tipoAccionContable();

        const today = new Date();
        const formattedFecha = format(today, 'yyyy-MM-dd'); 

        const filtroInicial: FiltroMovimientosContables = {
            codigoAccion: FiltroMovimientoContable.Todas,
            fecha: formattedFecha as unknown as Date,
        };
       
    };

    inicializar();
}, []);



    const { COLUMNS } = useColumns();
    const columns = useMemo(() => COLUMNS, [dataMovimiento]);

    const breadcrumbItems = [
        { label: 'Inicio', url: '/' },
        { label: 'Contabilidad', url: `/contabilidad` },
        { label: 'Consultar movimientos contables', active: true },
    ]

    const onSubmit = async (data: FiltroMovimientosContables) => {
        await getMovimientosContables(data);

    };

    const handleClicEmitir = async () => {
        const emitir = await descargarMovimientoContable(dataMovimiento)
    };


    return (
        <>
            <Suspense>
                <Breadcrumb items={breadcrumbItems} />
                <Box sx={{ mt: 2 }}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Suspense>
                            <CustomAccordion
                                title='Filtros'
                                expandedDefault
                            >
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <Grid2 container spacing={2}>
                                        <Grid2 size={3}>
                                            <InputSelect
                                                name="codigoAccion"
                                                control={control}
                                                error={errors.codigoAccion}
                                                label="Acción contable"
                                                options={options}

                                            />
                                        </Grid2>
                                        <Grid2 size={3}>
                                            <InputFecha
                                                name="fecha"
                                                control={control}
                                                label="Fecha"
                                                error={errors.fecha}
                                            />
                                        </Grid2>
                                        <Grid2 size={3} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                                            <MButton type="submit" variant="contained" color="primary" startIcon={<FilterList />}>
                                                Filtrar
                                            </MButton>
                                        </Grid2>
                                    </Grid2>
                                </form>
                            </CustomAccordion>
                            <Tabla
                                columns={columns}
                                data={dataMovimiento}
                                titulo={
                                    <TableHeader
                                        title=""
                                        button={
                                            <PermissionGuard permissions={[TipoFuncionalidad.Conta_ver_movs]}>
                                            <MButton
                                                type="button"
                                                variant="contained"
                                                onClick={() => { handleClicEmitir() }}
                                                startIcon={<SummarizeTwoToneIcon />}
                                            >
                                                Emitir
                                            </MButton>
                                            </PermissionGuard>
                                        }
                                        buttonExport={
                                            <PermissionGuard permissions={[TipoFuncionalidad.Transversal_exportar]}>
                                            <MButton
                                                type="button"
                                                variant="outlined"
                                                onClick={() => exportExcel(dataMovimiento, columns, "Movimientos contables")}
                                                startIcon={<SummarizeTwoToneIcon />}
                                            >
                                                Exportar
                                            </MButton>
                                            </PermissionGuard>
                                        }
                                    />
                                }
                            />
                        </Suspense>
                    </Paper>
                </Box>


            </Suspense>

        </>
    );
};
export default ConsultarMovimientosContables;